import {validApplicationTypeGuard} from './abstract-application.guard';

export const validAssetFinanceGuard = () => {
  return validApplicationTypeGuard('AssetFinance', 'e-not-asset');
}

